import { defineSagaForService, DownloadServiceConfiguration } from '@repo/core'
import {
  consolidatedPortfolioConfig,
  consolidatedPortfolioDownloadConfig,
} from './consolidatedPortfolio'
import { globalPositionConfig, globalPositionDownloadConfig } from './globalPosition'

export const serviceConfig = defineSagaForService({
  ...consolidatedPortfolioConfig,
  ...globalPositionConfig,
})

export const fileDownloadConfig = {
  ...consolidatedPortfolioDownloadConfig,
  ...globalPositionDownloadConfig,
} as Record<string, DownloadServiceConfiguration>
